import '@fontsource-variable/jetbrains-mono';
import '@hgc/ui/styles/tokens.css';
import './styles/index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';

const container = document.getElementById('root');
if (container === null) throw new Error('找不到 #root 挂载点，index.html 可能被改坏了');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
